// @flow
import React, {Component} from 'react';
import {Image, StyleSheet, View} from 'react-native';
import {Text, EmphasizedSubText} from 'trpc-react-native-ui';
import get from 'lodash/get';
import {Icon} from '../common';
import theme from '../../theme-config';

class RequiredItem extends Component<Props> {
  getRequiredIllustrationConfig = (iconName) => {
    return get(theme, `requiredToSignUp.${iconName}`);
  };

  renderIllustration = () => {
    const {iconName} = this.props;
    const illustrationConfig = this.getRequiredIllustrationConfig(iconName);

    if (!illustrationConfig || illustrationConfig.useIcon) {
      return <Icon name={iconName} size={44} color={theme.secondaryColor} />;
    }

    return (
      <Image
        style={styles.illustration}
        resizeMode="contain"
        source={illustrationConfig.image}
      />
    );
  };

  render() {
    const {itemCount, itemDescription} = this.props;

    return (
      <View style={styles.card}>
        <View style={styles.illustrationContainer}>
          {this.renderIllustration()}
        </View>
        <Text style={styles.itemCount}>{itemCount}</Text>
        <EmphasizedSubText
          style={styles.itemDescription}
          emphStyle={styles.adviseEmphasis}
          text={itemDescription}
        />
      </View>
    );
  }
}

const styles = StyleSheet.create({
  card: {
    width: 260,
    backgroundColor: '#FFFFFF',
    borderRadius: 12,
    borderWidth: 1,
    borderColor: '#EEEEEE',
    padding: 20,
    margin: 8,
    alignItems: 'center',
  },
  illustrationContainer: {
    marginBottom: 12,
    alignItems: 'center',
    justifyContent: 'center',
  },
  illustration: {
    width: 70,
    height: 70,
  },
  itemCount: {
    fontSize: 20,
    fontWeight: '700',
    color: theme.primaryColor,
    marginBottom: 6,
    fontFamily: 'Gotham',
  },
  itemDescription: {
    fontSize: 14,
    lineHeight: 20,
    textAlign: 'center',
    color: theme.signUpTextColor,
    fontFamily: 'Gotham',
  },
  adviseEmphasis: {
    fontWeight: 'bold',
    fontSize: 14,
  },
});

type Props = {
  itemDescription: string,
  itemCount: string,
  iconName: string,
  imageWidth?: number,
  imageHeight?: number,
  fontSizeCount?: number,
  fontSizeDescription?: number,
  inverted: boolean,
  isDesktop: boolean,
};

export default RequiredItem;
